interface ViewerMarketTradeQueryOptions {
  market: string;
  from: string;
  user?: string;
  outcomeIndex?: string;
  mints?: string[];
}

interface ViewerMarketTradeQueryArgs {
  market: string;
  from: string;
  outcomeIndex?: string;
  user?: string;
  mints?: string[];
}

/**
 * Shared scope for a viewer's market trades. The detail chart and thesis prompt
 * use this with `VIEWER_TRADE_PROJECTION` on their default window; winner
 * charts retain their narrower outcome/mint scope without affecting that
 * normal-market entry.
 */
export function viewerMarketTradeQueryArgs({
  market,
  from,
  user,
  outcomeIndex,
  mints,
}: ViewerMarketTradeQueryOptions): ViewerMarketTradeQueryArgs {
  return {
    market,
    from,
    ...(outcomeIndex !== undefined ? { outcomeIndex } : {}),
    ...(user !== undefined ? { user } : {}),
    ...(mints !== undefined ? { mints } : {}),
  };
}
